<template>
    <div class="orderList layout-page-box">
        <el-header class="orderTop">
            <div class="search">
                <!-- 姓名，性别，手机号，卡号 -->
                <el-autocomplete :disabled="disabled" :highlight-first-item="true" v-model="info" :fetch-suggestions="querySearchAsync" placeholder="请输入客户姓名、手机号、编号查找,无匹配按回车新增" :select-when-unmatched="true" @select="handleSelect" prefix-icon="el-icon-user-solid">
                    <!-- <i class="el-icon-edit el-input__icon" slot="suffix" @click="handleIconClick"></i> -->
                    <template slot-scope="{ item }">
                        <span class="name">{{item.name}}</span>
                        <span class="addr">{{item.sex}}</span>
                        <div class="addr">手机号:{{item.mobileFlag}}</div>
                        <div class="addr">卡号:{{item.cadCode}}</div>
                    </template>
                    <el-button slot="append" icon="el-icon-delete" @click="delInfo"></el-button>
                </el-autocomplete>
            </div>
            <div class="button">
                <div>
                    <span class="order">补单</span>
                    <el-switch @change="switchChange" v-model="value" active-color="#ff8646" inactive-color="#dcdfe6">
                    </el-switch>
                </div>
                <div>
                    <el-button type="warning" :plain="plain1" @click="plainBill" size="small">购买</el-button>
                    <el-button type="warning" :plain="plain2" @click="plainCustom" size="small">划扣</el-button>
                    <el-button type="warning" :plain="plain3" @click="plainHistory" size="small">历史消费</el-button>
                </div>
            </div>
        </el-header>
        <div class="layout-page-box box-header" ref="boxHeader">
            <el-form :inline="true" label-position="right" class="search-form" :rules="rules" :model="userInfo" ref="formData">
                <el-form-item label="日期" prop="sknDate">
                    <div class="empName">
                        <el-date-picker :disabled="dateDisabled" @input="testSX" :picker-options="pickerOptions" v-model="userInfo.sknDate" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="院区" prop="earId">
                    <div class="special">
                        <el-select clearable v-model="userInfo.earId" placeholder="请选择" ref="earId" @change="earChange" @input="testSX">
                            <el-option v-for="item in areaAndFloorList" :key="item.id" :label="item.areaName" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="楼层" prop="sknFloor">
                    <div class="special">
                        <el-select clearable v-model="userInfo.sknFloor" placeholder="请选择" @input="testSX">
                            <el-option v-for="item in userInfo.floorOptions" :key="item.id" :label="item.floorName" :value="item.floorName">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="初/复诊" prop="status">
                    <div class="special">
                        <el-select @input="testSX" clearable v-model="userInfo.status" placeholder="请选择">
                            <el-option v-for="item in statusOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="客户标签" prop="flag">
                    <div class="special">
                        <el-select @input="testSX" clearable v-model="userInfo.flag" placeholder="请选择">
                            <el-option v-for="item in flagOption" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="咨询师" prop="empName">
                    <div class="empName">
                        <el-select @focus="focus" @keydown.enter.native="enterDoctor($event, 4)" default-first-option :filter-method="empMatch" @input="testSX" v-model="userInfo.ctmEmpName" ref="empName" clearable placeholder="请选择咨询师" filterable remote allow-create>
                            <el-option v-for="item in newList3" :key="item.id" :label="item.empName" :value="item.empName"></el-option>
                        </el-select>
                    </div>
                </el-form-item>

                <el-form-item label="病历号" prop="caseCode">
                    <div class="empName">
                        <el-input @input="testSX" clearable v-model="userInfo.caseCode" placeholder="请输入病历号" oninput="value=value.replace(/[\u4E00-\u9FA5]/g, '')"></el-input>
                    </div>
                </el-form-item>

                <el-form-item label="信息来源" prop="informationSource">
                    <el-select @input="testSX" clearable filterable :disabled="userInfo.information == 0 ? true : false" v-model="userInfo.sceName" placeholder="请选择信息来源">
                        <el-option v-for="item in sourceList" :key="item.id" :label="item.sourceName" :value="item.sourceName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item> -->
            </el-form>
        </div>
        <!-- 开单模块 -->
        <bill :tableData="tableData" :counts="counts" v-show="flag1" :userInfo="userInfo"></bill>
        <!-- 消耗模块 -->
        <consume :tableList="tableList" :filters="filters" v-show="flag2" :userInfo="userInfo" :childData="childData" :refundData="refundData" :childInject="childInject"></consume>
        <!-- 历史消费 -->
        <historical v-if="flag3" :userInfo="userInfo"></historical>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import bill from './bill'
import consume from './consume'
import historical from './historical'
import { setTimeout } from 'timers';
import { userInfo } from 'os';
export default {
    name: 'orderList',
    components: {
        bill, consume, historical
    },
    data() {
        return {
            userInfo: {},
            plain1: false,
            plain2: true,
            plain3: true,
            tableData: [],
            tableList: [],
            aaData: [],
            bbData: [],
            restaurants: [],
            disabled: false,
            info: '',
            flag1: true,
            flag2: false,
            flag3: false,
            filters: {},
            newList3: [],
            rules: {
                sknDate: [{ required: true, message: "请选择日期", trigger: "blur" }],
                earId: [{ required: true, message: "请选择院区", trigger: "blur" }],
                sknFloor: [{ required: true, message: "请选择楼层", trigger: "blur" }],
                status: [{ required: true, message: "请选择初复诊", trigger: "blur" }],
                caseCode: [{ required: true, message: "请输入病历号", trigger: "blur" }],
                flag: [{ required: true, message: "请选择客户标签", trigger: "blur" }],
                sceName: [
                    { required: true, message: "请选择信息来源", trigger: "blur" },
                ],
                ctmEmpName: [{ required: true, message: "请添加咨询师", trigger: "blur" }],
            },
            counts: {
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0,
                },
            },
            filters: {
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0,
                },
            },
            childData: [],
            refundData: [],
            childInject: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            ccData: [],
            dateDisabled: true,
            value: false,
        }
    },
    computed: {
        ...mapState(["statusOptions", "flagOption",]),
        ...mapGetters(["list3", "sourceList", "areaAndFloorList"]),
    },
    watch: {
        $route(to) {
            // 判断是消耗入口还是开单入口
            this.init()
        }
    },
    created() {
        this.$store.dispatch('getIdList')
        this.init()
    },
    methods: {
        init() {
            // 判断是消耗入口还是开单入口
            if (this.$route.name == 'orderList') {
                this.bill()
                // console.log(this.$route.params);
            } else if (this.$route.name == 'consumeList') {
                this.customStatus()
                // console.log(this.$route.params);
            }
            this.initData()
        },
        initData() {
            this.userInfo = this.$route.params
            // 该用户已购买项目
            if (this.userInfo.ctmName) {
                this.userInfo.mobileFlag = this.arrmethod(this.userInfo.ctmMobile)
                this.info = this.userInfo.ctmName + '【' + this.userInfo.ctmSex + '】' + '【' + this.userInfo.mobileFlag + '】' + '【' + this.userInfo.ctmCode + '】'
                this.disabled = true
                if (this.userInfo.infoCode == 0) {
                    this.bill()
                } else if (this.userInfo.infoCode == 1) {
                    this.customStatus()
                }
                this.getProject(this.userInfo.ctmMobile, '', 1)
                // console.log(this.userInfo);
            } else if (this.userInfo.codeName == 1) {
                this.disabled = false
                this.info = ''
                this.restaurants = []
                this.userInfo = {}
                this.tableData = []
                this.tableList = []
                this.filters.pagination.total = 0
                this.counts.pagination.total = 0
                this.delData()
            }
            this.userInfo.sknDate = new Date();
            this.userInfo.flag = "无";
        },
        arrmethod(mobile) {
            let arr = []
            mobile.split(' ').forEach(ele => {
                arr.push(ele.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2"))
            });
            return arr.toString()
        },
        formValidate() {
            return new Promise((resolve, reject) => {
                // console.log(this.$refs.formData);
                this.$refs.formData.validate((valid) => {
                    if (valid) {
                        resolve(this.userInfo);
                    } else {
                        setTimeout(() => {
                            reject("error");
                        });
                    }
                });
                this.$forceUpdate();
            });
        },
        testSX() {
            this.$forceUpdate();
        },
        // 开单状态
        bill() {
            // 按钮
            this.plain1 = false
            this.plain2 = true
            this.plain3 = true
            // 模块
            this.flag1 = true
            this.flag2 = false
            this.flag3 = false
        },
        // 消耗状态
        customStatus() {
            // 按钮
            this.plain1 = true
            this.plain2 = false
            this.plain3 = true
            // 模块
            this.flag1 = false
            this.flag2 = true
            this.flag3 = false
        },
        // 购买
        plainBill() {
            this.bill()
            this.userInfo.infoCode = 0
            // 获取数据
            if (this.userInfo.ctmMobile) {
                this.getProject(this.userInfo.ctmMobile, '', this.counts.pagination.page)
            }
        },
        // 划扣
        plainCustom() {
            this.customStatus()
            this.userInfo.infoCode = 1
            // 获取数据
            if (this.userInfo.ctmMobile) {
                this.getProject(this.userInfo.ctmMobile, '', this.filters.pagination.page)
            }

        },
        // 历史记录
        plainHistory() {
            // 按钮
            this.plain1 = true
            this.plain2 = true
            this.plain3 = false
            // 模块
            this.flag1 = false
            this.flag2 = false
            this.flag3 = true
        },

        // 模糊查询方法
        handleSelect(item) {
            // console.log(item);
            if (item.name) {
                this.getProject(item.mobile, '', 1)
                this.getData(item)
                this.getClientStatus(1, item.name, item.mobile, item.cadCode)
            } else {
                _g.toast('error', '暂无此数据,请先新增客户')
            }

        },
        getEarId(item) {
            let arr = this.areaAndFloorList;
            arr.forEach((ele) => {
                if (item.earId == ele.id) {
                    this.userInfo.floorOptions = ele.floorNameList;
                }
            });
        },
        getData(item) {
            this.userInfo.mobileFlag = this.arrmethod(item.mobile)
            this.info = item.name + '【' + item.sex + '】' + '【' + this.userInfo.mobileFlag + '】' + '【' + item.cadCode + '】'
            this.userInfo.ctmEmpName = item.empName
            this.userInfo.sceName = item.informationSource
            this.userInfo.information = item.information
            this.userInfo.cadCode = item.cadCode
            this.userInfo.ctmMobile = item.mobile
            this.userInfo.ctmName = item.name
            this.userInfo.caseCode = item.caseCode
            this.userInfo.ctmSex = item.sex
            this.userInfo.ctmAge = item.age
            this.userInfo.earId = item.earId
            this.getEarId(item)
            this.userInfo.sknDate = new Date();
            this.userInfo.flag = "无";
            if (this.flag1 == true) {
                this.userInfo.infoCode = 0
            } else if (this.flag2 == true) {
                this.userInfo.infoCode = 1
            }
            this.disabled = true
        },
        // 获取历史消费数据判断初诊复诊
        getClientStatus(page, name, mobile, cadCode) {
            var querys = {
                name: name,
                mobile: mobile,
                cadCode: cadCode,
                page: 1,
                size: 10,
            };
            api.request("/skn/getClientConsumeInformation", querys, (res) => {
                if (res.result == true) {
                    var data = res.data.list;
                    if (data.length == 0) {
                        this.userInfo.status = "1";
                        this.$forceUpdate()
                    } else if (data.length != 0) {
                        this.userInfo.status = "2";
                        this.$forceUpdate()
                    }
                }
            }, (res) => { });
        },
        querySearchAsync(queryString, cb) {
            // console.log(queryString);
            if (queryString) {
                // 请求接口获取数据
                let data = {
                    comprehensive: queryString,
                }
                api.requestQuiet("/skn/getClientInformation", data, (res) => {
                    if (res.result == true) {
                        this.restaurants = res.data.mapList
                        // console.log(this.restaurants);
                        this.restaurants.forEach(ele => {
                            ele.information = 0
                            ele.mobileFlag = this.arrmethod(ele.mobile)
                        });
                        cb(this.restaurants);
                    } else if (res.result == false) {
                        this.restaurants = []
                        cb(this.restaurants);
                    }
                }, (err) => { });
            } else {
                cb(this.restaurants);
                return;
            }
        },
        // 获取已购买项目接口
        getProject(mobile, sknId, page) {
            let querys = {
                mobile: mobile,
                sknId: sknId,
            };
            api.request("/skn/getPurchaseInformation", querys, (res) => {
                if (res.result == true) {
                    var data = res.data.list;
                    this.$nextTick(() => { // 请求成功之后，在这里执行
                        // 开单页面分页数据
                        if (this.userInfo.infoCode == 0) {
                            this.aaData = data
                            this.counts.pagination.total = parseInt(res.data.count);
                            this.tableData = this.aaData.slice((page - 1) * this.counts.pagination.limit, page * this.counts.pagination.limit)
                            this.tableData.forEach((el, i) => {
                                el.$index = (page - 1) * this.counts.pagination.limit + 1 + i;
                            });
                        } else if (this.userInfo.infoCode == 1) {
                            // 消耗页面分页数据
                            this.bbData = data
                            this.filters.pagination.total = parseInt(res.data.count);
                            this.tableList = this.bbData.slice((page - 1) * this.filters.pagination.limit, page * this.filters.pagination.limit)
                            this.tableList.forEach((el, i) => {
                                el.$index = (page - 1) * this.filters.pagination.limit + 1 + i;
                            });
                        }
                    })
                }
            }, (res) => {
            });
        },
        switchChange(val) {
            if (val == true) {
                this.dateDisabled = false
            } else if (val == false) {
                this.dateDisabled = true
                this.userInfo.sknDate = new Date();
            }
        },
        handleIconClick(ev) {
            console.log(ev);
        },
        // 删除查找个人信息
        delInfo() {
            this.disabled = false
            this.info = ''
            this.restaurants = []
            this.userInfo = {
                flag: '无',
                sknDate: new Date(),
            }
            this.tableData = []
            this.tableList = []
            this.filters.pagination.total = 0
            this.counts.pagination.total = 0

        },
        delData() {
            this.childData = []
            this.refundData = []
            this.childInject = []
        },
        earChange(val) {
            this.$nextTick(() => {
                this.userInfo.earName = this.$refs.earId.selected.label;
            });
            // this.userInfo.sknFloor = "";
            let arr = this.areaAndFloorList;
            arr.forEach((ele) => {
                if (val == ele.id) {
                    this.userInfo.floorOptions = ele.floorNameList;
                }
            });
            if (this.userInfo.earId == "") {
                this.userInfo.floorOptions = [];
            }
            this.$forceUpdate()
        },
        focus() {
            this.newList3 = this.list3;
        },
        empMatch(val) {
            this.newList3 = _g.paramMatch(this.list3, this.newList3, val, 'empName')
        },
    }
}
</script>
<style scoped>
.layout-page-box {
  padding: 0px;
}
.orderTop {
  border: 1px solid #eee;
  width: 100%;
  height: 50px !important;
  display: flex;
  align-items: center;
}
.search {
  width: 40%;
  border-right: 1px solid #eee;
}
.button {
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* text-align: right; */
}
.orderList >>> .el-autocomplete {
  width: 100%;
}
.orderList {
  min-height: calc(100% - 30px);
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
.name {
  margin-right: 10px;
}
.box-header {
  background: #eee;
}
.special >>> .el-select .el-input__inner {
  width: 100px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.special >>> .el-input__inner {
  width: 82px;
  height: 30px;
  line-height: 30px;
}
.empName >>> .el-select .el-input__inner {
  width: 150px;
  height: 30px;
  line-height: 30px;
}
.empName >>> .el-input__inner {
  width: 150px;
  height: 30px;
  line-height: 30px;
}
.empName >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px;
}
.layout-page-box >>> .el-form-item {
  margin-bottom: 18px !important;
}
.layout-page-box >>> .el-form-item__content {
  line-height: 30px !important;
}
.order {
  font-size: 14px;
  margin-left: 10px;
}
</style>
<style>
.el-autocomplete-suggestion li {
  line-height: 18px !important;
  padding: 5px 20px;
}
.el-button i {
  margin-right: 0px !important;
}
</style>

